import { useSettingsPage } from './useSettingsPageVM';
import { Tabs } from 'components/Tabs/Tabs';
import { SettingsTabs } from './SettingsTabs';
import './Settings.scss';

export const SettingsPage: React.FunctionComponent = () => {
    const { activeTab, setActiveTab } = useSettingsPage();

    return (
        <>
            <Tabs
                tabs={SettingsTabs}
                activeTab={activeTab}
                onTabChange={(id) => {
                    setActiveTab(id);
                }}
            />
        </>
    );
};
